import React from "react";
import { withRouter } from "react-router-dom";
import { connectProps } from "store";
import {
  langProp,
  userIDProp,
  updateCollectionName,
  collectionName,
  updateProductID,
  updateLang,
  email
} from "model/component-props";
import CollectionCard from "../collectionCard/CollectionCard";
import spinner from "../../icons/spinner.svg";

import "./collections.css";

class Collections extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: true,
      collectionItems: [],
      itemVariant: [],
      collectionNames: [],
      activeLi: '',
      loading: true
    };
  }

  componentDidMount() {

    fetch(`${process.env.REACT_APP_NODE_SERVER}/getB2BcollectionNames`, {
      crossDomain: true,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("HTTP error " + response.status);
      })
      .then((data) => {
        console.log(data);
        this.setState({ collectionNames: data.value});
        this.getCollection(data.value[0].Code)
      });
  }

  getCollection = (code) => {
    this.setState({ activeLi: code })
    this.setState({ collectionItems: [] })
    this.setState({ loading: true})

    fetch(`${process.env.REACT_APP_NODE_SERVER}/getB2BcollectionItems`, {
      crossDomain: true,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
        body: JSON.stringify({
          query: `filter=Code eq '${code}'`,
          username: this.props.email,
          code: code
        }),
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("HTTP error " + response.status);
      })
      .then((data) => {
        this.setState({ loading: false})
        this.setState({ collectionItems: data.value});
        this.props.updateCollectionName(code);
      });
  }

  handleClick = () => {
    this.setState({
        lang: !this.state.lang
    });

    if(this.state.lang === true){
        this.props.updateLang('GR');
    } else {
        this.props.updateLang('EN');
    }

}

  render() {
    const collectionItems = this.state.collectionItems || [];
    const collectionNames = this.state.collectionNames

    return (
      <div>
      <div
      className="language-selector-container">
        {this.state.lang ? <span style={{position: 'absolute', top: '1px', right: '66px'}}>EN</span> : <span style={{position: 'absolute', top: '1px', right: '66px'}}>GR</span>}
        <label className="switch">
            <input
              onClick={this.handleClick}
              type="checkbox"
            />
        <div></div>
        </label>
    </div>
        <div className="wrap">
          <nav>
            <ul className="primary">
            <span style={{color:'#123C69'}}>Collections</span>
              {
                collectionNames.map((name) => {
                  return (
                    <li className={`listItem${this.state.activeLi === name.Code ? ' selected' : ''}`}
                    key={name.Code}>
                    <a onClick={() => this.getCollection(name.Code)}
                    >{name.Name}</a>
                  </li>
                  )
                })
              }
             
            </ul>
          </nav>
        </div>
            <div className={this.state.loading ? "container-customersList" : 'none'}>
              <img src={spinner} alt="spinner" className="spinner" />
            </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            paddingLeft: "30px",
          }}
        >
          {collectionItems.map((item, i) => {
            return (
              <CollectionCard
                key={item.No}
                id={item.No}
                description={this.props.langProp === 'EN' ? item.ENUDescription : item.ELLDescription}
                url={`${process.env.REACT_APP_NODE_SERVER}/thumbs/${item.No}.JPG`}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default connectProps(
  langProp,
  userIDProp,
  updateCollectionName,
  collectionName,
  updateProductID,
  updateLang,
  email
)(withRouter(Collections));



// WEBPACK FOOTER //
// ./src/components/collections/Collections.js